import React from "react";
import Icon from "../../Icon";
import { convertIntToMoney } from "../../../helpers/conversions";

/**
 * Card de indicador (KPI) do dashboard.
 *
 * @param {string|node} icon  nome do ícone (ver componente Icon) ou um elemento pronto
 * @param {string} label   descrição curta do indicador
 * @param {string|number} value  valor já formatado (quando não for money)
 * @param {number} money   quando informado, `value` é ignorado e o número
 *                          (em centavos) é formatado como moeda com prefixo R$
 * @param {string} accent  cor do chip do ícone: brand | coral | teal | cobalt | amber
 * @param {string|node} hint  texto auxiliar exibido abaixo do valor
 * @param {boolean} loading  exibe estado de carregamento
 */
export const BoxKpi = ({ icon, label, value, money, accent = "brand", hint, loading }) => {
    return (
        <div className={`box-kpi accent-${accent}`}>
            <div className="box-kpi-icon">
                {typeof icon === 'string' ? <Icon name={icon} size={20} /> : icon}
            </div>
            <div className="box-kpi-content">
                <span className="box-kpi-label">{label}</span>
                {loading ? (
                    <span className="box-kpi-value skeleton">&nbsp;</span>
                ) : (
                    <span className="box-kpi-value">
                        {money !== undefined && money !== null && (
                            <span className="currency">R$</span>
                        )}
                        {money !== undefined && money !== null
                            ? convertIntToMoney(money)
                            : value}
                    </span>
                )}
                {hint && !loading && <span className="box-kpi-hint">{hint}</span>}
            </div>
        </div>
    );
};

export default BoxKpi;
